import React from 'react';
import { FolderOpen } from 'lucide-react';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  secondaryAction?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  secondaryAction,
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center text-center p-8 sm:p-12 bg-white rounded-3xl border border-[#E5E9E9] shadow-xs my-4 space-y-4 ${className}`}>
      <div className="w-14 h-14 rounded-2xl bg-[#E8FAF9] text-[#1fb4ac] flex items-center justify-center border border-[#56E8E1]/40 shadow-xs">
        {icon || <FolderOpen className="w-7 h-7" />}
      </div>
      <div className="max-w-md space-y-1.5">
        <h3 className="text-base sm:text-lg font-bold text-[#111111]">{title}</h3>
        {description && <p className="text-xs sm:text-sm text-[#5F6368] leading-relaxed">{description}</p>}
      </div>
      {(action || secondaryAction) && (
        <div className="flex flex-col sm:flex-row items-center gap-3 pt-2">
          {action}
          {secondaryAction}
        </div>
      )}
    </div>
  );
};
